import "./MDLHome.scss";
import { useEffect, useState } from "react";
import MDLArticle from "../../ui/MDLArticle/MDLArticle";
import { articleService, Article } from "../../services/articleService";

const MDLHome = () => {
  const [articles, setArticles] = useState<Article[]>([]);

  useEffect(() => {
    articleService.initializeHardcodedData();
    const allArticles = articleService.getAllArticles();
    setArticles(allArticles);
  }, []);

  return (
    <div id="mdl-home">
      {articles.length > 0 && (
        <div className="articles-container">
          <h2>Aktuelles</h2>
          {articles.map((article) => (
            <div key={article.id} className="article-wrapper">
              <MDLArticle id={article.id} elements={article.elements} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MDLHome;
